import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../../config/constants';
import { Outlet, useOutletContext } from 'react-router';
import './monitDataStructure.scss';
import useAsync from '../../../hooks/useAsync';
import Loading from '../../components/Loading';
import { useDispatch, useSelector } from 'react-redux';
import { setLogout } from '../../../reducer/authentication';

function DetailedDataStructs(props) {
    const { selSumDsId } = useOutletContext();
    const dispatch = useDispatch();
    const onLogout = () => dispatch(setLogout());
    const { userRank, privilege } = useSelector((state) => state.session);
    const [result, setResult] = useState([]);
    async function getDataStructures() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getDataStructures`, { sumDsId: selSumDsId });
        setResult(response.data);
    }
    useEffect(() => {
        if (!privilege?.detailedDataStruct.read) onLogout();
    }, [privilege]);

    useEffect(() => {
        getDataStructures();
    }, [selSumDsId])

    return (
        <div className='dataStructure'>
            <Outlet context={{
                dataStructures: result,
                setDataStructures: setResult,
            }} />
        </div>
    );
}

export default DetailedDataStructs;